export const getDayStartTimestamp = (date?: Date) => {
  const day = date || new Date();
  return new Date(day.getFullYear(), day.getMonth(), day.getDate());
}